(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("styled-components"), require("react"), require("immutable"), require("whatwg-fetch"));
	else if(typeof define === 'function' && define.amd)
		define(["styled-components", "react", "immutable", "whatwg-fetch"], factory);
	else if(typeof exports === 'object')
		exports["wordliftForSchemaOrg"] = factory(require("styled-components"), require("react"), require("immutable"), require("whatwg-fetch"));
	else
		root["wordliftForSchemaOrg"] = factory(root["styled-components"], root["react"], root["immutable"], root["whatwg-fetch"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__9__) {
return 